import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

// 创建 Vuex 存储实例
const store = new Vuex.Store({
  // ...
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js